// Function to detect if flex gap is supported
function supportsFlexGap() {
  var flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px';
  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div'));
  document.body.appendChild(flex);
  var isSupported = flex.scrollHeight === 1;
  document.body.removeChild(flex);
  return isSupported;
}

function addDynamicMarginFallback() {
    const allElements = document.querySelectorAll('div, ul, form, button');
    for (let element of allElements) {
        const style = getComputedStyle(element);
        if (style.display === 'flex' || style.display === 'inline-flex') {
            const gap = style.gap;
            if (gap) {
                const [rowGap, columnGap] = gap.split(' ').map(g => g.trim());
                const children = element.children;
                for (let i = 0; i < children.length - 1; i++) {
                    if (style.flexDirection === 'column' || style.flexDirection === 'column-reverse') {
                        children[i].style.marginBottom = rowGap || columnGap;
                    } else {
                        children[i].style.marginRight = columnGap || rowGap;
                    }
                }
            }
        }
    }
}

window.addEventListener('DOMContentLoaded', () => {
  if (!supportsFlexGap()) {
    document.body.classList.add('flex-box-gap-not-supported')
    console.log('Flexbox gap is not supported, applying fallback.');
    addDynamicMarginFallback();
  } 

  const isSafari = navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');

  if (isSafari) {
    document.body.classList.add('browser-safari');
  }
});
